/** Splitting on dots lets `cart title` match dotted keys like `cart.line.title`. */
export function queryTerms(query: string): string[] {
  return query
    .toLowerCase()
    .split(/[\s.]+/)
    .filter(Boolean);
}

export function matchesTerms(terms: string[], label: string, value: string): boolean {
  const haystack = `${label} ${value}`.toLowerCase();
  return terms.every((term) => haystack.includes(term));
}
